export default __webpack_public_path__ + "static/media/dash-careers4a.d8dffa84.svg";